export var CartDrawerText;
(function (CartDrawerText) {
    CartDrawerText["CLOSE"] = "CLOSE";
    CartDrawerText["ORDER_FOR"] = "Order for";
})(CartDrawerText || (CartDrawerText = {}));
